import React, { Fragment } from 'react';
import ScrollLock from 'react-scrolllock';
import './instructions.css';
import enterance from '../../../../images/ParkingLots/Instructions/Toronto/enterance.png';
import enterance2 from '../../../../images/ParkingLots/Instructions/Toronto/enterance2.png';
import map from '../../../../images/ParkingLots/Instructions/Toronto/map.jpeg';
import { Helmet } from 'react-helmet';

const KingInstructions = () => (
  <Fragment>
    <Helmet>
      <title>Autzu | Parking Instructions</title>
      <meta
        name="description"
        content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
      />
    </Helmet>

    <div className="instructions">
      <ScrollLock>
        <div className="instructions__container">
          <div className="instructions__title_container">
            <div className="instructions__title">
              Finding the Parking Hub
            </div>
            <div className="instructions__subtitle">
              621 King St W - Downtown Toronto
            </div>
          </div>
          <div className="instructions__body">
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>How do I access the parking lot?</strong>
              </div>
              <img className="instructions__image" src={map} />
              <p className="instructions__body-text">
                Autzu EV vehicles are parked in the Omni Park facility at
                the Thompson Residences, 621-629 King St. W, on the P2 and
                P4 levels. The closest intersection is Bathurst St. and
                King. St. West.
              </p>
              <p className="instructions__body-text">
                The parking lot is a short walk from St. Andrew and Union
                subway stations and easily accessible by streetcars from
                both St. Andrew and Bathurst subway stations. (Route
                504/514 on King St. West and Route 511 on Bathurst St.)
              </p>
            </div>
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot by walking?
                </strong>
              </div>
              <img className="instructions__image" src={enterance} />
              <p className="instructions__body-text">
                Follow the signage to the public parking elevator for
                direct access to the parking lot. Autzu EV vehicles are
                parked on P2 and P4. The elevator is accessible 24/7, and
                no fob is required.
              </p>
            </div>
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot with my personal vehicle?
                  (free parking)
                </strong>
              </div>
              <img className="instructions__image" src={enterance2} />
              <p className="instructions__body-text">
                Enter through the parking lot ramp, and the gate will open
                automatically. Drive down to P2 or P4 (check the Autzu app
                to see which car you have been assigned), and you can park
                your personal vehicle for free in the same parking spot.
              </p>
            </div>
          </div>
        </div>
      </ScrollLock>
    </div>
  </Fragment>
);

export default KingInstructions;



// WEBPACK FOOTER //
// ./src/components/Static/ParkingLots/Toronto/KingInstructions.js